
export default {
  props: {
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      required: true
    },
    titleColor: {
      type: String,
      default: 'black'
    }
  }
}
